import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, ActivatedRoute } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import { navigation } from '../../../_conf/navigation/navigation';

import { UserService,User } from '../../../users/users.module';
import { AccountProvider } from 'src/app/users/services/user.service';
import { ConfiguracionService } from 'src/app/configuracion/configuracion.service';
import { environment } from '../../../../environments/environment';

@Component({
    selector   : 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls  : ['./toolbar.component.scss']
})

export class ToolbarComponent implements OnInit, OnDestroy
{
    readonly version = `${environment.app_version}`;;
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    showLoadingBar: boolean;
    userStatusOptions: any[];
    isAdminWeb: boolean;
    nombre: string;
    public user: User = new User();
    public allowRandomPunchings: boolean = false;


  private userSubscription: Subscription;
    // Private
    private _unsubscribeAll: Subject<any>;
  private _unsubscribeuser: Subject<any>;
    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {Router} _router
     * @param {TranslateService} _translateService
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private _router: Router,
        private _translateService: TranslateService,
        private _accountProvider: AccountProvider,
        private _userService: UserService,
        private _navConfigService: ConfiguracionService,
        private _route: ActivatedRoute
    )
    {
        // Set the defaults
        this.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];

        //this.languages = [
        //  {
        //    id: 'es',
        //    title: 'Español',
        //    flag: 'es'
        //  }
        //  ,{
        //        id   : 'en',
        //        title: 'English',
        //        flag : 'us'
        //    }
            
        //];
        this.navigation = navigation;
        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this._unsubscribeuser = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
  ngOnInit(): void {
    // Subscribe to the router events to show/hide the loading bar
    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        takeUntil(this._unsubscribeAll)
      )
      .subscribe((event) => {
        this.showLoadingBar = true;
      });

    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd)
      )
      .subscribe((event) => {
        this.showLoadingBar = false;
      });

    // Subscribe to the config changes
    this._fuseConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((settings) => {
        this.horizontalNavbar = settings.layout.navbar.position === 'top';
        this.rightNavbar = settings.layout.navbar.position === 'right';
        this.hiddenNavbar = settings.layout.navbar.hidden === true;

      });

    // Set the selected language from default languages
    this.selectedLanguage = _.find(this.languages, { 'id': this._translateService.currentLang });

    this.userSubscription = this._accountProvider.userInfo.subscribe((userInfo) => {
      this.user = userInfo;
    });

    let url = window.location.pathname.split('/', 2)[1]
    let pathes = ['login', 'recuperar']
    let loginOrRecoverBool = pathes.every(path => { return !url.startsWith(path) })
    if (loginOrRecoverBool) {
      this._navConfigService.get().subscribe((config: any) => {
        // this.hideGenarateRandomPunchings(config.allowRandomPunchings);
        this.allowRandomPunchings = config.allowRandomPunchings; // sirve en front-end para ocultar opción menú usuario.
        if (!config.allowRandomPunchings)
          this.hideNavbarOption('fichajes', 'autofichaje');
      }, (error) => { })
    }
  }

  private hideNavbarOption(groupName, optionName) {
    // Eliminamos opción del grupo del menú lateral izquierdo.
    let group = this.navigation.find(f => f.id == groupName);
    if (group) {
      let option = group.children.find(f => f.id == optionName);
      if (option)
        option.hidden = true;
    }
  } 

  public hideGenarateRandomPunchings() {
    if (!this.allowRandomPunchings) {
      this.hideNavbarOption('fichajes', 'autofichaje');
      /*
      // Parchecito para ocultar opción del menú lateral (no de usuario).
      let randomPunchings = document.querySelector("[href='/generar-autofichajes']")
      if (randomPunchings)
        randomPunchings.setAttribute('style', 'display:none');
      */
    }
  }


  /**
   * On destroy
   */
  ngOnDestroy(): void {
      // Unsubscribe from all subscriptions
      this._unsubscribeAll.next();
      this._unsubscribeAll.complete();
      this._unsubscribeuser.next();
      this._unsubscribeuser.complete();
      if (this.userSubscription) {
        this.userSubscription.unsubscribe();
      }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void
    {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    /**
     * Search
     *
     * @param value
     */
    search(value): void
    {
        // Do your search here...
        console.log(value);
    }

    /**
     * Set the language
     *
     * @param langId
     */
    setLanguage(langId): void
    {
        // Set the selected language for toolbar
        this.selectedLanguage = _.find(this.languages, {'id': langId});

        // Use the selected language for translations
        this._translateService.use(langId);
    }

  logout() {
    this._userService.logout();
    this._router.navigateByUrl('/login');
  }

  verEmpleado() {
    if (!this.user) {
      this._accountProvider.load()
    }
    this._router.navigate(['empleado', this.user.empleadoId]);
  }

  public doNothing(evt: Event) {
    evt.stopPropagation();
  }
}
